import { CLAIM_LIST_TYPES, CLAIM_STATUSES } from '../../../utils/constants';
import Vue from 'vue';
import { parseDate } from '@eui-util/date';

export default [
  {
    name: 'claimId',
    label: 'Ref #',
    align: 'left',
    field: 'claimId'
  },
  {
    name: 'claimDate',
    label: 'Claim Date',
    align: 'left',
    field: 'claimDate',
    format: (val) => parseDate(val, 'yyyy-MM-dd')
  },
  {
    name: 'description',
    label: 'Description',
    align: 'left',
    field: 'claimType',
    format: (val) => (CLAIM_LIST_TYPES[val] ? CLAIM_LIST_TYPES[val].label : val)
  },
  {
    name: 'amount',
    label: 'Amount',
    align: 'left',
    field: 'total',
    format: (val) => Vue.filter('currency')(val)
  },
  {
    name: 'status',
    label: 'Status',
    align: 'left',
    field: 'statusName',
    format: (val) => (CLAIM_STATUSES[val] ? CLAIM_STATUSES[val].label : val)
  },
  {
    name: 'receipt',
    label: '',
    field: 'fileIds'
  }
];
